import React, { useState } from "react";

// Video imports
import video1 from "../assets/video/Vajram.mp4";
import video2 from "../assets/video/Subham_Avenues.mp4";
import video3 from "../assets/video/MahaLakshmi_Golden_City.mp4";

const projects = [
  { id: 1, src: video1, title: "Vajram" },
  { id: 2, src: video2, title: "Subham Avenues" },
  { id: 3, src: video3, title: "MahaLakshmi Golden City" },
];

const VideoPage = () => {
  const [activeProject, setActiveProject] = useState(projects[0]);

  return (
    <div className="w-full flex flex-col bg-white">

      {/* 1. TOP NAVIGATION BAR (Now sitting ABOVE the video) */}
      <nav className="w-full py-6 px-4 flex flex-wrap justify-center gap-3 bg-gray-50 border-b border-gray-200">
        <div className="flex flex-col items-center ">
          <h2 className="text-4xl font-serif font-bold tracking-wide text-center mb-6">
            Our Projects
          </h2>
          <div className="flex flex-wrap justify-center gap-3 bg-white p-2 rounded-full shadow-md border border-gray-200">

            {projects.map((project) => (
              <button
                key={project.id}
                onClick={() => setActiveProject(project)}
                className={`px-8 py-2.5 rounded-full text-sm font-bold transition-all duration-300 shadow-sm border
              ${activeProject.id === project.id
                    ? "bg-slate-800 text-white border-slate-800 scale-105 shadow-md"
                    : "bg-white text-gray-600 border-gray-300 hover:border-gray-400 hover:bg-gray-100"
                  }`}
              >
                {project.title}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {/* 2. VIDEO CONTAINER (Now relative to the flow) */}
      <div className="relative w-full aspect-video md:h-[80vh] bg-black overflow-hidden shadow-2xl">
        <video
          key={activeProject.src}
          className="w-full h-full object-cover animate-fade-in"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={activeProject.src} type="video/mp4" />
        </video>

        {/* Subtle Branding Overlay (Optional) */}
        <div className="absolute bottom-10 left-10 z-10">
          <h2 className="text-white text-3xl font-bold tracking-tight drop-shadow-lg">
            {activeProject.title}
          </h2>
          <div className="h-1 w-20 bg-yellow-500 mt-2"></div>
        </div>

        {/* Dark Vignette for focus */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0.8; transform: scale(1.02); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fade-in { 
            animation: fadeIn 0.5s ease-out forwards; 
        }
      `}</style>
    </div>
  );
};

export default VideoPage;